import { useMemo } from 'react'
import PropTypes from 'prop-types'
import styled, { keyframes } from 'styled-components'
import { t } from 'ttag'

import { base } from '../../mixins'
import { PB30T } from '../../colors'
import { Headed2LogoIcon } from '../../icons/headed2Logo'

const logoWidth = '48'
const loaderFrames = keyframes`
  0% {
    left: 0;
    opacity: 1;
    transform: rotate(0deg);
  }
  25% {
    opacity: .3;
  }
  45% {
    transform: rotate(0deg);
    left: calc(100% - ${logoWidth}px);
  }
  50% {
    transform: rotate(900deg);
    opacity: 1;
  }
  75% {
    opacity: .3;
  }
  95% {
    left: 0;
    transform: rotate(900deg);
  }
  100% {
    left: 0;
    opacity: 1;
    transform: rotate(0deg);
  }
`
const Wrap = styled.div`
  position: relative;
  width: ${({ animationWidth }) => animationWidth ?? '356px'};
  min-height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
`
const Heading = styled.h3`
  ${base}
  font-family: 'vag-rundschrift-d', 'Nunito', Helvetica, Arial, sans-serif;
  font-size: 24px;
  font-weight: 400;
  line-height: 30px;
  text-align: center;
  letter-spacing: 0.05em;
  color: ${({ color }) => color};
  margin: 0;
  white-space: nowrap;
`
const Logo = styled(Headed2LogoIcon)`
  position: absolute;
  animation: ${loaderFrames} 6s ease-in-out infinite;
`
/**
 * The Loader displays a message with an animated H2 logo.
 */
const Loader = ({ msg = t`Loading, please wait...`, color = PB30T }) => {
  const animationWidth = useMemo(() => {
    return `${msg.trim().split('').length * 12.5 + 2.5 * logoWidth}px`
  }, [msg])

  return (
    <Wrap animationWidth={animationWidth}>
      <Heading color={color}>
        <span>{msg}</span>
      </Heading>
      <Logo size="large" />
    </Wrap>
  )
}

Loader.propTypes = {
  /** The message to display in the Loader. */
  msg: PropTypes.string,
  /** The color of the message string. */
  color: PropTypes.string
}

export { Loader }
